import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const SmartLinkEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-issue-field-smart-link" */ './index').then(
			(module) => module.SmartLink,
		),
	),
	getPreloadProps: () => ({}),
});
